import { useState, useEffect } from 'react';
import { Snackbar } from '@mui/material';
import {
  alterarFavoritoFixado,
  deletarTelaFavoritada,
  listarFavoritos
} from '../../../api/autenticacao';
import { useMenuSidebar } from '../../../contexts/MenuSidebarContext';
import { removeDepartamentoStorage } from '../../../services/authentication/auth';

const useFavoritosHook = setEscopoAcesso => {
  const [listaDeFavoritos, setListaDeFavoritos] = useState([]);
  const [isPendingMenu, setIsPendingMenu] = useState(false);
  const [filtro, setFiltro] = useState('');
  const { excluirTelaAtual } = useMenuSidebar();
  const [qtdFixados, setQtdFixados] = useState(0);
  const [alertaErro, setAlertaErro] = useState(false);

  const filtrar = (valorFiltro, loader = true) => {
    setIsPendingMenu(loader);
    listarFavoritos(valorFiltro)
      .then(response => {
        setListaDeFavoritos(response.data);

        if (response.data) {
          const fixados = response.data.filter(favorito => favorito.FIXADO === 'S').length;
          setQtdFixados(fixados);
        }
      })
      .catch(err => {
        console.error('Erro ao listar favoritos:', err);
      })
      .finally(() => {
        setIsPendingMenu(false);
      });
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      filtrar(filtro);
    }
  };

  useEffect(() => {
    filtrar('');
    excluirTelaAtual();
  }, []);

  const handleToggleFavorito = favorito => {
    setIsPendingMenu(true);
    deletarFavorito(favorito);
  };

  const handleTogglePin = favorito => {
    setQtdFixados(qtdFixados + 1);
    alterarFixados(favorito);
  };

  const alterarFixados = favorito => {
    if (qtdFixados >= 3 && favorito.FIXADO === 'N') {
      return;
    }

    const params = {
      CODFAVORITOUSUARIOTELA: favorito.CODFAVORITOUSUARIOTELA,
      FIXADO: favorito.FIXADO === 'S' ? 'N' : 'S'
    };

    setIsPendingMenu(true);
    alterarFavoritoFixado(params)
      .then(() => {
        filtrar(filtro);
      })
      .catch(err => {
        console.error('Erro ao alterar favorito:', err);
      });
  };

  const deletarFavorito = favorito => {
    deletarTelaFavoritada(favorito.CODSUBMENU)
      .then(() => {
        removeDepartamentoStorage(favorito.CODDEPARTAMENTO);
        filtrar(filtro);
      })
      .catch(err => {
        console.error('Erro ao deletar favorito:', err);
      });
  };

  const AlertErro = msgErro => (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={alertaErro}
      onClose={() => setAlertaErro(false)}
      message={msgErro}
    />
  );

  const handleOnChangePesquisar = e => {
    setFiltro(e.target.value);
    if (e.target.value === '') {
      filtrar('');
    }
  };

  return {
    filtrar,
    listaDeFavoritos,
    isPendingMenu,
    handleKeyDown,
    setFiltro,
    filtro,
    handleToggleFavorito,
    handleTogglePin,
    qtdFixados,
    AlertErro,
    handleOnChangePesquisar
  };
};

export default useFavoritosHook;
